import { create } from 'zustand';

/**
 * Controla o modal global de upsell do freemium. É disparado tanto pela UI
 * quanto pelo interceptor do axios (quando uma ação mutativa é bloqueada no
 * modo somente-leitura), por isso vive fora da árvore React.
 */
interface FreemiumUpsellState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useFreemiumUpsellStore = create<FreemiumUpsellState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

/** Atalho para abrir o upsell fora de contexto React (ex.: interceptor). */
export const openFreemiumUpsell = () =>
  useFreemiumUpsellStore.getState().open();
